import { format, isValid, startOfMonth } from 'date-fns';

export const getDateParam = (date?: Date) =>
  date && isValid(date) ? format(date, 'yyyy-MM-dd') : undefined;

export const parseDateParam = (dateStr?: string) => {
  if (!dateStr) return undefined;

  const date = new Date(dateStr);
  return isValid(date) ? date : undefined;
};

const addDaysToDateParam = (dateStr: string, amount: number) => {
  const date = parseDateParam(dateStr);
  if (!date) return '';

  date.setDate(date.getDate() + amount);
  return getDateParam(date) ?? '';
};

const getEarlierDateParam = (firstDate: Date, secondDate: Date) =>
  getDateParam(firstDate <= secondDate ? firstDate : secondDate) ?? '';

/**
 * Chuẩn hóa khoảng ngày sử dụng khi tìm kiếm:
 * - Cho phép chọn ngày tương lai.
 * - Nếu người dùng chỉ chọn ngày đến, tự lùi ngày bắt đầu 30 ngày.
 * - Nếu người dùng chỉ chọn ngày bắt đầu, tự lấy ngày kết thúc là ngày bắt đầu + 30 ngày.
 */
export const getUsageDateSearchRange = (
  reservationDateFrom?: string,
  reservationDateTo?: string,
) => {
  if (reservationDateFrom && reservationDateTo) {
    return { reservationDateFrom, reservationDateTo };
  }

  if (reservationDateTo) {
    return {
      reservationDateFrom: addDaysToDateParam(reservationDateTo, -30),
      reservationDateTo,
    };
  }

  if (reservationDateFrom) {
    return {
      reservationDateFrom,
      reservationDateTo: addDaysToDateParam(reservationDateFrom, 30),
    };
  }

  return { reservationDateFrom: '', reservationDateTo: '' };
};

/**
 * Chuẩn hóa khoảng ngày đặt khi tìm kiếm:
 * - Không cho ngày kết thúc vượt quá hôm nay.
 * - Nếu người dùng chỉ chọn ngày đến, tự lùi ngày bắt đầu 30 ngày.
 * - Nếu người dùng chỉ chọn ngày bắt đầu, tự lấy ngày kết thúc là ngày nhỏ hơn giữa
 *   ngày bắt đầu + 30 ngày và hôm nay.
 */
export const getCreatedDateSearchRange = (
  createdAtFrom?: string,
  createdAtTo?: string,
) => {
  if (createdAtFrom && createdAtTo) {
    return { createdAtFrom, createdAtTo };
  }

  if (createdAtTo) {
    return {
      createdAtFrom: addDaysToDateParam(createdAtTo, -30),
      createdAtTo,
    };
  }

  if (createdAtFrom) {
    const maxToDate = parseDateParam(addDaysToDateParam(createdAtFrom, 30));

    return {
      createdAtFrom,
      createdAtTo: maxToDate ? getEarlierDateParam(maxToDate, new Date()) : '',
    };
  }

  return { createdAtFrom: '', createdAtTo: '' };
};

export const getDefaultCreatedDateFilter = () => {
  const today = new Date();

  return {
    createdAtFrom: getDateParam(startOfMonth(today)),
    createdAtTo: getDateParam(today),
  };
};
